import type { Products } from "../types"

export const products: Products = new Map([
  [
    "mev-capital-bera",
    {
      name: "MEV Capital Berachain Cluster",
      entity: "mev-capital",
      description:
        "The MEV Capital Berachain Cluster provides a set of liquid collateral markets with an optimized risk-adjusted return",
      vaults: [
        "0xad9e5E2647EFb9137B6B8D688d4906fa51476870",
        "0x6D976915bD9DE43De1A60C39e128e320dadda000",
        "0xb758d6eC8111FEB9b0EC758A61B7874e5821dfFd",
        "0xd538b6aeF78E4bDDe4FD4576E9E3A403704602bc",
        "0x1371dD58ce95eCD624340F072f97212A2661A280",
        "0x826244d9Db2A0f438C3190a0f393c13d41AD7a2E",
        "0x91e1Ec1e948F635c127dad41eaE1aF899399F15a",
        "0x413dfb1814A6B5fe4488c49f86e2a74D285ffd5b",
        "0x85Dba39B85218229a4c3B9b037d05CD6eB4cF05D",
        "0x558B16E07b8558b2a54946cA973b7b20B86A8b87",
        "0x3de0CA4AF11108c94c9066a935ee67e53b7f9447",
        "0x2CCCd307bB616E5F896Ab61CaE09Ef4E5e9fEdB7",
        "0xB8064453B25a91D7a4e8b7e7883A817D5742dE34",
        "0x1dfB669DF5E70D4238F2Cc0a9EE3b1a21FF91bC0",
        "0xBaBF4ce18FBab547Ad5939dEFf825f3E2f8d9402",
      ],
    },
  ],
  [
    "tulipa-hive",
    {
      name: "Tulipa Hive",
      description:
        "A market tailored to lending and borrowing assets such as WBTC, LBTC, Honey, USDC, BERA and NECT on the Bera chain. Governed by Tulipa.",
      entity: "tulipa-capital",
      vaults: [
        "0x027DcAfB223f69d41Bd413C50854017718419585",
        "0xE932da5A4d00536c224f8153f299cDcD8054c444",
        "0x542B1ffd33C239C7AFc6511FB8855390Aa9c8aC2",
        "0x16C7169421CfB2C78b2D447b9274c61B8b2E846a",
        "0x4f652B92a8CD9e251Db4d43b2073F689E94B4Dba",
        "0x07346aE3245E04C96E33E8d8e02a638AaA08E719",
      ],
    },
  ],
  [
    "re7-labs-bera",
    {
      name: "Re7 Labs Cluster",
      entity: "re7-labs",
      vaults: [
        "0x89FD57175EcEEC45992e07c206e5A864Fa6aF433",
        "0x66f233ac844C3948A516857CA769872E5941f91c",
        "0xe318d262290ABab80FC6e217c514801e2c0EF999",
        "0x109D6D1799f62216B4a7b0c6e245844AbD4DD281",
        "0x5ba8763891D6a4F934B197B9817757d887B78fec",
      ],
    },
  ],
  [
    "tulipa-folding-hive",
    {
      name: "Tulipa Folding Hive",
      description:
        "A collaboration between Origami Finance and Tulipa Capital on folding oriBGT. Governed by Tulipa.",
      entity: "tulipa-capital",
      vaults: [
        "0xac0476A04c567EBcd49Db0A5b8b294A119d7849D",
        "0xCaa70d2aa873Ef057980844e18D9a9560bdfFcC0",
      ],
    },
  ],
  [
    "mev-capital-red",
    {
      name: "MEV Capital Berachain Red Cluster",
      entity: "mev-capital",
      description:
        "The MEV Capital Berachain Red Cluster provides a set of native collateral markets with an optimized risk-adjusted return",
      vaults: [
        "0x028b1F7a949a7a862C3f93987296be30d71f7F97",
        "0x7C7717F9bbd6126A013215796da04201d6A78d6b",
        "0x746d425Dd3Cf924fC7a0f37EBED10E35fF589342",
        "0xB127DbA67C3f83c1aCcBB9a124E1b6f6bC3E93f3",
        "0x8c0d62cEC0920f33c76cC99cfb703De060289D4A",
      ],
    },
  ],
  [
    "zerolend-bera-party",
    {
      name: "ZeroLend Prime Market",
      description: "A Berachain-focused market curated by ZeroLend.",
      entity: "zerolend",
      vaults: [
        "0x28C96C7028451454729750171BD3Bb95D7261B5a",
        "0x112B77A77753b092306b1c04Bd70215FeD4e00a1",
        "0x1B33D24C4C78a61DA80Cfa2d0dB72ca0851d5fb1",
        "0x2247B618251b8d913F3fD10B749e7bfa3E3a28db",
        "0x401c4633dCa173bf75ac85F2D270d98c063F54CF",
        "0x2Bf927248f86Bd78ce300d00C7c8A175e3e0B38a",
      ],
    },
  ],
  [
    "mev-capital-blue",
    {
      name: "MEV Capital Berachain Blue Cluster",
      entity: "mev-capital",
      description:
        "The MEV Capital Berachain Blue Cluster provides a set of native collateral markets with an optimized risk-adjusted return",
      vaults: [
        "0x34018ac9DC4B114036Ca148Aa18C8f75594E5e95",
        "0x4eB3351066494852a03ffBBDE40a9776380Ce20D",
        "0xE3ecE76A7D1B07BcB0B5B6D38091E47C45994043",
      ],
    },
  ],
])
